RCA.client.Surveys = (function () {
    'use strict';
    /* ----- Declare Variables ---------------------------------------------------------------------------------------- */
    var
        $templateSurveysItem,
        $templateSurveysStarRating,
        $templateSurveysStarGroupRating,
        $templateSurveysStarGroupRatingItem,
        $templateSurveysRadio,
        $templateSurveysRadioItem,
        $templateSurveysCheck,
        $templateSurveysCheckItem,
        $templateSurveysMatrixCheck,
        $templateSurveysMatrixCheckItem,
        $templateSurveysMatrixCheckItemTitle,
        $templateSurveysText,
        $templateSurveysHidden;
    var ar;
    var noRequiredItem = true;

    RCA.shared.localState.surveys = RCA.shared.localState.surveys || {};
    RCA.shared.localState.surveys.itemIndex = RCA.shared.localState.surveys.itemIndex || 0;

    /* ----- Init Surveys --------------------------------------------------------------------------------------------- */
    function Init() {
        $templateSurveysItem = $('template#tplSurveysItem').remove().contents();
        $templateSurveysStarRating = $('template#tplSurveysStarRating').remove().contents();
        $templateSurveysStarGroupRating = $('template#tplSurveysStarGroupRating').remove().contents();
        $templateSurveysStarGroupRatingItem = $templateSurveysStarGroupRating.find('template#tplSurveysStarGroupRatingItem').remove().contents();
        $templateSurveysRadio = $('template#tplSurveysRadio').remove().contents();
        $templateSurveysRadioItem = $templateSurveysRadio.find('template#tplSurveysRadioItem').remove().contents();
        $templateSurveysCheck = $('template#tplSurveysCheck').remove().contents();
        $templateSurveysCheckItem = $templateSurveysCheck.find('template#tplSurveysCheckItem').remove().contents();

        $templateSurveysMatrixCheck = $('template#tplSurveysMatrixCheck').remove().contents();
        $templateSurveysMatrixCheckItem = $templateSurveysMatrixCheck.find('template#tplSurveysMatrixCheckItem').remove().contents();
        $templateSurveysMatrixCheckItemTitle = $templateSurveysMatrixCheck.find('template#tplSurveysMatrixCheckItemTitle').remove().contents();

        $templateSurveysText = $('template#tplSurveysText').remove().contents();
        $templateSurveysHidden = $('template#tplSurveysHidden').remove().contents();
        renderList();
        renderDetails();
        // AppData.
        delete RCA.client.Surveys.Init;
    }

    function sortSurveys(data) {
        data.sort(function(a,b) {
            if (a.sort_id !== undefined && b.sort_id !== undefined) {
                return parseInt(a.sort_id) > parseInt(b.sort_id) ? 1 : -1;
            } else {
                return 0;
            }
        })
    }
    /* ----- Build Attendees List ----------------------------------------------------------------------------------- */
    function renderList() {

        var
            $self = $('#surveys #surveysList'),
            $fragmentSurveys = $(document.createDocumentFragment()),
            data = RCA.shared.AppData.surveys.filter(function (el) {
                return el.active === true;
            });
        sortSurveys(data);
        $.each(data, function (i, el) {
            if(el.active) {
                var $clone = $templateSurveysItem.clone();
                $clone.attr('data-index', el.id);
                $clone.find('.filledsurveydisplay').css('display', isFilledSurvey(el) ? 'block' : 'none');
                // $clone.find('.chevron').show();
                $clone.find('.chevron').css('display', isFilledSurvey(el) ? 'none' : 'block');
                $clone.find('.data-title').text(el.title[RCA.shared.localState.lang]);
                $clone.appendTo($fragmentSurveys);
            }
        });
        $self.html($fragmentSurveys);
        $('#surveys .no-result').toggle(Boolean(!data.length));
    }


    function isFilledSurvey(el) {
        var surveysdata = RCA.shared.AppData.surveysdata.filter(function(e) {
            return e.survey === el.id;
        });
        var answers_multiple_times = el.answers_multiple_times === undefined ? false : el.answers_multiple_times;
        return surveysdata.length > 0 && !answers_multiple_times;
    }

    /* ----- Build Details -------------------------------------------------------------------------------------------- */
    function renderDetails() {
        if ('surveys' in RCA.shared.localState) {
            var
                $details = $('#surveys-details article'),
                $header = $('#surveys-details .data-label'),
                $fragmentDetails = $(document.createDocumentFragment()),
                $clone,
                $cloneItem,
                $cloneItemTitle,
                el = RCA.shared.AppData.surveys.find(function (el) {
                    return el.id === RCA.shared.localState.surveys.itemIndex;
                }) || RCA.shared.AppData.surveys[0],
                filled = RCA.shared.AppData.surveysdata.find(function (el) {
                    return el.survey === RCA.shared.localState.surveys.itemIndex;
                });

            if (!el) return false;
            filled = Boolean(filled) && !el.answers_multiple_times;
            $header.text(el.title[RCA.shared.localState.lang]);
            //$header.text(AppData.languages[AppData.settings.lang]['nav-surveys']);
            $details.find('.survey_title h3').html(el.title[RCA.shared.localState.lang]);
            ar = new Array();

            $.each(el.parts, function (index, item) {

                let asterisk = '';
                if (item.answer_required && el.show_asterisk) {
                    asterisk = ' *';
                }

                let name = undefined;

                switch (item.type) {
                    case 'grouprating':
                        name = 'parts_' + index;
                        $clone = $templateSurveysStarGroupRating.clone();
                        $clone.find('.data-title').text(item.question[RCA.shared.localState.lang] + asterisk);
                        if(item.description !== undefined)
                            $clone.find('.data-description').html(item.description[RCA.shared.localState.lang]).css('display', 'block');
                        if(item.answers) {
                            $.each(item.answers[RCA.shared.localState.lang].split('||'), function (j, answer) {
                                $cloneItem = $templateSurveysStarGroupRatingItem.clone();
                                $cloneItem.find('.data-label').text(answer);
                                $cloneItem.find('input').attr("data-id", item.id); // .val(answer);
                                if(item.rating_star_count !== undefined && item.rating_star_count != '' && item.rating_star_count > 0) {
                                    for(var i = 0; i  < item.rating_star_count ; i++) {
                                        $cloneItem.find('.rating_icons').html($cloneItem.find('.rating_icons').html() + '<i class="far fa-fw fa-2x fa-star"></i>');
                                    }
                                }
                                $cloneItem.appendTo($clone);
                            });
                        }
                        $clone.find('.answer-required').val(String(item.answer_required));
                        $clone.find('input').attr('data-answer-required', String(item.answer_required));
                        $clone.appendTo($fragmentDetails);
                        if(item.answer_required)
                            if($.inArray('parts_' + index, ar) == -1)
                                ar.push('parts_' + index);
                        break;
                    case 'rating':
                        name = 'parts_' + index;
                        $clone = $templateSurveysStarRating.clone();
                        $clone.find('.data-title').text(item.question[RCA.shared.localState.lang] + asterisk);
                        if(item.description !== undefined)
                            $clone.find('.data-description').html(item.description[RCA.shared.localState.lang]).css('display', 'block');
                        $clone.find('.answer-required').val(String(item.answer_required));
                        $clone.find('input').attr("data-id", item.id);
                        $clone.find('input').attr('data-answer-required', String(item.answer_required));
                        $clone.appendTo($fragmentDetails);
                        if(item.rating_star_count !== undefined && item.rating_star_count != '' && item.rating_star_count > 0) {
                            for(var i = 0; i  < item.rating_star_count ; i++) {
                                 $clone.find('.rating_icons').html($clone.find('.rating_icons').html() + '<i class="far fa-fw fa-2x fa-star"></i>');
                             }
                        }
                        if(item.answer_required)
                            if($.inArray('parts_' + index, ar) == -1)
                                ar.push('parts_' + index);
                        break;
                    case 'radio':
                        name = 'parts_' + index;
                        $clone = $templateSurveysRadio.clone();
                        $clone.find('.data-title').text(item.question[RCA.shared.localState.lang] + asterisk);
                        if(item.description !== undefined)
                            $clone.find('.data-description').html(item.description[RCA.shared.localState.lang]).css('display', 'block');
                        if(item.answers) {
                            $.each(item.answers[RCA.shared.localState.lang].split('||'), function (j, answer) {
                                $cloneItem = $templateSurveysRadioItem.clone();
                                $cloneItem.find('.data-label').text(answer);
                                $cloneItem.find('input').val(answer);
                                $cloneItem.appendTo($clone);
                            });
                        }
                        $clone.find('.answer-required').val(String(item.answer_required));
                        $clone.find('input').attr("data-id", item.id);
                        $clone.find('input').attr('data-answer-required', String(item.answer_required));
                        $clone.appendTo($fragmentDetails);
                        if(item.answer_required)
                            if($.inArray('parts_' + index, ar) == -1)
                                ar.push('parts_' + index);
                        break;
                    case 'check':
                        name = 'parts_' + index;
                        $clone     = $templateSurveysCheck.clone();
                        $cloneItem = $templateSurveysCheckItem.clone();
                        var isMinMax   = item.checkbox_min !== "" && item.checkbox_max !== "" && item.checkbox_min > 0 && item.checkbox_max > item.checkbox_min;
                        var isRequired = item.answer_required || isMinMax;
                        $clone.find('.data-title').text(item.question[RCA.shared.localState.lang] + (isRequired ? asterisk : ''));
                        if(item.description !== undefined)
                            $clone.find('.data-description').html(item.description[RCA.shared.localState.lang]).css('display', 'block');
                        if (item.answers) {
                            $.each(item.answers[RCA.shared.localState.lang].split('||'), function (j, answer) {
                                $cloneItem = $templateSurveysCheckItem.clone();
                                $cloneItem.find('.data-label').text(answer);
                                $cloneItem.find('input').val(answer);
                                $cloneItem.find('input').addClass('parts_' + index);
                                if(isRequired) {
                                    $cloneItem.find('input').attr('data-name', 'parts_' + index );
                                    if ($.inArray('parts_' + index , ar) == -1) {
                                        ar.push('parts_' + index );
                                    }

                                }

                                $cloneItem.appendTo($clone);
                            });
                        }
                        $clone.find('.answer-required').val(String(item.answer_required));
                        $clone.find('input').attr("data-id", item.id);
                        $clone.find('input').attr('data-answer-required', String(item.answer_required));
                        $clone.find('input').attr('data-checkbox_min', String(item.checkbox_min));
                        $clone.find('input').attr('data-checkbox_max', String(item.checkbox_max));
                        $clone.appendTo($fragmentDetails);
                        break;
                    case 'matrix_check':
                        $clone     = $templateSurveysMatrixCheck.clone();
                        $cloneItemTitle = $templateSurveysMatrixCheckItemTitle.clone();
                        $cloneItem = $templateSurveysMatrixCheckItem.clone();
                        var isRequired = item.answer_required;
                        $clone.find('.data-title').text(item.question[RCA.shared.localState.lang] + (isRequired ? asterisk : ''));
                        if(item.description !== undefined)
                            $clone.find('.data-description').html(item.description[RCA.shared.localState.lang]).css('display', 'block');

                        $clone.find('.data-matrix').css({
                            "grid-template-columns": Array(item.headers[RCA.shared.localState.lang].split(',').length + 1).fill("1fr").join(" ")
                        });

                        $clone.find('.data-matrix').append('<div class="text-center"></div>');
                        $.each(item.headers[RCA.shared.localState.lang].split(','), function (h, header) {
                            $clone.find('.data-matrix').append('<div class="text-center">'+header+'</div>');
                        });

                        if (item.answers) {
                            $.each(item.answers[RCA.shared.localState.lang].split('||'), function (j, answer) {
                                $cloneItemTitle = $templateSurveysMatrixCheckItemTitle.clone();
                                $cloneItemTitle.html(answer);
                                $cloneItemTitle.appendTo($clone.find('.data-matrix'));

                                $.each(item.headers[RCA.shared.localState.lang].split(','), function (h, header) {
                                    $cloneItem = $templateSurveysMatrixCheckItem.clone();
                                    //$cloneItem.find('.data-label').text(answer);
                                    $cloneItem.find('input').attr('name', 'parts_' + index + '_' + j + '_' + h);
                                    $cloneItem.find('input').val(header);
                                    $cloneItem.find('input').addClass('parts_' + index + '_' + j + '_' + h);
                                    if(isRequired) {
                                        $cloneItem.find('input').attr('data-name', 'parts_' + index + '_' + j + '_' + h );
                                        if ($.inArray('parts_' + index + '_' + j + '_' + h , ar) == -1) {
                                            ar.push('parts_' + index + '_' + j + '_' + h );
                                        }

                                    }

                                    $cloneItem.appendTo($clone.find('.data-matrix'));
                                });
                            });
                        }
                        $clone.find('.answer-required').val(String(item.answer_required));
                        $clone.find('input').attr("data-id", item.id);
                        $clone.find('input').attr('data-answer-required', String(item.answer_required));
                        $clone.appendTo($fragmentDetails);
                        break;
                    case 'text':
                        name = 'parts_' + index;
                        $clone = $templateSurveysText.clone();
                        $clone.find('.data-title').text(item.question[RCA.shared.localState.lang] + asterisk);
                        if(item.description !== undefined)
                            $clone.find('.data-description').html(item.description[RCA.shared.localState.lang]).css('display', 'block');
                        $clone.find('textarea').attr("data-id", item.id);
                        $clone.find('textarea').attr('placeholder', RCA.shared.Language.getItem('write-here'));
                        $clone.find('textarea').attr('data-answer-required', String(item.answer_required));
                        $clone.find('.answer-required').val(String(item.answer_required));
                        $clone.appendTo($fragmentDetails);
                        if(item.answer_required)
                            if($.inArray('parts_' + index, ar) == -1)
                                ar.push('parts_' + index);
                        break;
                }
                noRequiredItem = noRequiredItem && !item.answer_required;
                if (name != undefined) {
                    $clone.find('input, textarea').attr('name', name);
                }
            });

            if(el.survey_description)
                $details.find('.survey_description').html(el.survey_description[RCA.shared.localState.lang]).show();

            $details.find('.items').html($fragmentDetails);
            $details.find('[type=submit]').addClass('disabled');
            $details.find('.data-thank-you-text').html(el.thxtext[RCA.shared.localState.lang]);
            $details.find('.data-thank-you').toggle(filled);
            $details.find('.data-thank-you .fill-again').toggleClass("hidden", !el.show_fill_again);
            $details.find('form').toggle(!filled);
            $clone = null;
        }
    }

    /* ----- Build from File ------------------------------------------------------------------------------------------ */
    function BuildFromSource() {
        $.post('api/', {
            do: 'getSurveys'
        }, function (data) {
            RCA.shared.AppData.surveys = data;
            $.post('api/', {
                do: 'getSurveysData'
            }, function (res) {
                RCA.shared.AppData.surveysdata = res;
                renderList();
                renderDetails();
                res = null;
            });
            data = null;
        })
    }

    /* ----- Event: Click on Item ------------------------------------------------------------------------------------- */
    function evtClick() {
        RCA.shared.localState.surveys.itemIndex = String($(this).data('index')) || 0;
        if($(this).find(".filledsurveydisplay").is(":visible")) {
            RCA.shared.writeDbLog("view filled", RCA.shared.localState.surveys.itemIndex, "user_logs", "surveys");
        } else {
            RCA.shared.writeDbLog("start fill",  RCA.shared.localState.surveys.itemIndex, "user_logs", "surveys");
        }
        renderDetails();
        RCA.client.Layout.show('surveys-details');
    }

    /* ----- Reser Form ----------------------------------------------------------------------------------------------- */
    function resetForm() {
        var $survey = $('#surveys-details form');
        $survey.find('input[type=hidden]').val('');
        $survey.find('input[type=radio], input[type=checkbox]').prop('checked', false);
        $survey.find('label').removeClass('state-checked animated pulse');
        $survey.find('.fa-star').removeClass('fas').addClass('far');
        $survey.find('textarea').val('');
    }

    /* ----- Event: Change Input -------------------------------------------------------------------------------------- */
    function evtChangeInput() {
        var
            classList = 'state-checked animated pulse',
            $label = $(this).closest('label');
        if (this.type === 'radio') {
            $label.siblings().removeClass(classList);
        }

        if (this.type == "checkbox") {
            let max = parseInt($(this).attr("data-checkbox_max"));
            let checked = $(".state-checked", $(this).closest(".item")).length;
            if (checked == max) {
                $(this).prop("checked", false);
            }
        }
        $label.toggleClass(classList, this.checked);
    }

    /* ----- Event: Click Star ---------------------------------------------------------------------------------------- */
    function evtClickStar() {
        var $this = $(this);
        $this
            .prevAll().addBack()
            .removeClass('far').addClass('fas');
        $this
            .nextAll()
            .removeClass('fas').addClass('far');
        $this.parent().siblings('input').val($this.index() + 1).trigger('change');
    }

    /* ----- Event: Submit Form --------------------------------------------------------------------------------------- */
    function evtSubmitForm(e) {
        e.preventDefault();
        var
            $this = $(this),
            formData = RCA.shared.serializeObject($this);
        resetForm();

        let values = {};
        $.each($this.find("input, textarea"), function(i,e) {
            if(formData[e.name]) {
               values[e.name] = {"id": e.dataset.id, "type": e.type, "values": formData[e.name]};
            }
        });
        values.survey = RCA.shared.localState.surveys.itemIndex;

        RCA.shared.writeDbLog("submit", RCA.shared.localState.surveys.itemIndex, "user_logs", "surveys");

        if (RCA.shared.AppData.settings.start_survey == RCA.shared.localState.surveys.itemIndex && !RCA.shared.AppData.settings.keep_survey) {
            RCA.client.Layout.hide("surveys-details");
        }

        $this.hide();
        $this.closest('div.main').find('.data-thank-you').show();
        $this.closest('div.main').find('.survey_description').hide();

        $.post('api/', {
            do: 'saveSurveyData',
            data: values
        }, function (res) {
            RCA.shared.AppData.surveysdata = res;
            renderList();
            res = null;
        });
    }

    /* ----- Event: Enable Submit on Input -------------------------------------------------------------------------- */
    function evtInput(e) {

        var validField,
            isMinMax = this.dataset.checkbox_min !== "" && this.dataset.checkbox_max !== "" && this.dataset.checkbox_min > 0 && this.dataset.checkbox_max > this.dataset.checkbox_min;

        var removefrom_req = [];

        switch (e.target.type) {
                case 'hidden':
                case 'radio':
                    validField = true;
                break;
                case 'textarea':
                    validField = e.target.value != '';
                    break;
                case 'checkbox':
                    var checkedCount = 0;
                    if ($(this).closest(".data-matrix").length > 0) {
                        $.each($(this).closest(".data-matrix").find("input[type=checkbox]"), function (i, e) {
                            validField = validField || e.checked;
                            if (e.checked) checkedCount++;
                        });

                        if (checkedCount > 0) {
                            validField = true;
                            $.each($(this).closest(".data-matrix").find("input[type=checkbox]"), function (i, e) {
                                removefrom_req.push(e.name);
                            });
                        }
                    } else {
                        $.each($("#surveys-details").find(".items ." + this.name), function (i, e) {
                            validField = validField || e.checked;
                            if (e.checked) checkedCount++;
                        });

                        if(isMinMax && checkedCount < this.dataset.checkbox_min)
                            validField = false;
                        if(isMinMax && checkedCount > this.dataset.checkbox_max)
                            validField = false;
                    }

                    break;
            }

            if (this.dataset.answerRequired == "true" || isMinMax)
                if (validField) {
                    if (removefrom_req.length > 0) {
                        for (var i = 0; i < removefrom_req.length; i++) {
                            ar = arrayRemove(ar, removefrom_req[i]);
                        }
                    } else {
                        ar = arrayRemove(ar, this.name);
                    }
                } else {
                    ar.push(this.name);
                }

        $(this).closest('form').find('[type=submit]').toggleClass('disabled', Boolean(ar.length != 0) );

    }

    function arrayRemove(arr, value) {

        return arr.filter(function(ele){
            return ele != value;
        });

    }

    function showQuestion(id) {
        if (id) {
            //if (id !== localState.surveys.itemIndex || localState.surveys.itemIndex === 0) {
                RCA.shared.localState.surveys.itemIndex = String(id);
                renderDetails();
            //}
            RCA.client.Layout.show('surveys-details');
        }
    }

    function showDetails(id) {
        if (id) {
            //if (id !== localState.surveys.itemIndex || localState.surveys.itemIndex === 0) {
                RCA.shared.localState.surveys.itemIndex = String(id);
                renderDetails();
            //}
            RCA.client.Layout.show('surveys-details');
        }
    }

    function fillAgain() {
        showDetails(RCA.shared.localState.surveys.itemIndex);
    }

    /* ----- Bind Events -------------------------------------------------------------------------------------------- */
    $(document)
        .on('change', '#surveys-details input[type=radio], #surveys-details input[type=checkbox]', evtChangeInput)
        .on('click', '#surveys #surveysList .item', evtClick)
        .on('input', '#surveys-details form textarea', evtInput)
        .on('change', '#surveys-details form input', evtInput)
        .on('click', '#surveys-details .survey-star .fa-star', evtClickStar)
        .on('click', '#surveys-details .fill-again', fillAgain)
        .on('submit', '#surveys-details form', evtSubmitForm);
    /* ----- Public API --------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        BuildFromSource: BuildFromSource,
        showQuestion: showQuestion,
        showDetails: showDetails,
        evtClickDetails: evtClick
    };
})();
